// extracted by mini-css-extract-plugin
export var cardIcon = "_61-5";
export var cardIconUnframed = "_61-9";
export var checkboxCard = "_61-0";
export var checkboxCardSelected = "_61-4";
export var disabled = "_61-2";
export var interactive = "_61-1";
export var outerBorder = "_61-3";
export var spacerMedium = "_61-8";
export var spacerSmall = "_61-7";
export var spacerXsmall = "_61-6";